import React from "react";

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#1c1c1c",
        color: "#fff",
        padding: "40px 0"
      }}
    >
      <div className="container">

        <div className="row">

          {/* COMPANY INFO */}
          <div className="col-md-4 mb-4">
            <h4 className="mb-3 text-warning">Rithan Promoters</h4>
            <p>
              Building trust. Delivering quality. 
              We provide premium residential plots and
              gated community projects across Tamil Nadu.
            </p>
          </div>

          {/* GIRIS GARDENS ADDRESS */}
          <div className="col-md-4 mb-4">
            <h5 className="text-success">Giris Gardens</h5>
            <p>
              Ottupattarai, Coonoor <br />
              Nilgiris, Tamil Nadu – 643105 <br />
              📞 9585928712
            </p>
          </div>

          {/* OFFICE ADDRESS */}
          <div className="col-md-4 mb-4">
            <h5 className="text-info">Head Office</h5>
            <p>
              11, Nadu Street <br />
              Gobichettipalayam <br />
              Erode District – 638452 <br />
              📞 7373723163 <br />
              ✉ rithanpromoters@gmail.com <br />
              🌐 www.rithanpromoters.com
            </p>
          </div>

        </div>

        <hr style={{ borderColor: "#444" }} />

        <div className="text-center">
          © {new Date().getFullYear()} Rithan Promoters. All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}

export default Footer;
